import React from "react";
import {SidebarTab, useSidebarElevationApp} from "./useSidebarElevationApp";
import {ElevationSidebarDetails} from "./ElevationSidebarDetails";

// the view-only drawing of a drw elevation: the details strip and the canvas.
export function ElevationSidebarDrawing(props: {
    project: number;
    alternative?: number;
    openingId: number;
    openingName: string;
    fingerprint: string;
    tab: SidebarTab;
}) {
    const {containerRef, app, overlay} = useSidebarElevationApp({
        projectId: props.project,
        openingId: props.openingId,
        alternative: props.alternative,
        fingerprint: props.fingerprint,
        tab: props.tab,
    });

    // position: relative, like the tool's drawfrm-root: the canvas' React overlays (dimension
    // popovers, load errors) position themselves against it.
    return (
        <div className="drawfrm-root" style={{
            flex: 1,
            display: "flex",
            flexDirection: "column",
            position: "relative",
            minHeight: 0,
        }}>
            <ElevationSidebarDetails
                app={app}
                tab={props.tab}
                project={props.project}
                alternative={props.alternative}
                openingId={props.openingId}
                openingName={props.openingName}
            />
            <div className="drawfrm-canvas" style={{
                flex: 1,
                minHeight: 0,
                overflow: "hidden",
                display: "flex",
                position: "relative",
            }} ref={containerRef} />
            {overlay.raw()}
        </div>
    );
}
